import React from 'react';
import './customizedColums.scss';
import Tooltip from '@mui/material/Tooltip';

const BomRevAlertCell = (props) => {
	const { dataItem } = props;

	const status = {
		1: ['cancel', 'icon missing-bom'],
		2: ['info', 'icon order-reprocessed'],
	};

	return (
		<td className="roboto-15-400 bom-rev-alert">
			{(dataItem.bomRevAlertEnum === 1 || dataItem.bomRevAlertEnum === 2) && (
				<Tooltip
					title={
						<div>
							{dataItem.bomRevAlert}
						</div>
					}
					placement="top"
				>
					<div>
						<span
							class={`${
								status[dataItem.bomRevAlertEnum][1]
							} material-symbols-outlined`}
						>
							{status[dataItem.bomRevAlertEnum][0]}
						</span>
					</div>
				</Tooltip>
			)}
		</td>
	);
};

export { BomRevAlertCell };
